module.exports = __webpack_public_path__ + "static/img/1.5a8b7eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting824/images/1.png
// module id = G6iG
// module chunks = 4